export const FacebookIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 12C24 5.37308 18.6269 0 12 0C5.37308 0 0 5.37308 0 12C0 17.989 4.38757 22.9537 10.1252 23.8549V15.4696H7.07749V12H10.1252V9.35565C10.1252 6.34847 11.9173 4.68626 14.6579 4.68626C15.9707 4.68626 17.3444 4.92083 17.3444 4.92083V7.874H15.8307C14.3406 7.874 13.8748 8.79876 13.8748 9.74884V12H17.2026L16.6711 15.4696H13.8748V23.8549C19.6124 22.9554 24 17.9907 24 12Z"
      fill="#1977F3"
    />
    <path
      d="M16.6711 15.4696L17.2027 12.0001H13.8749V9.74892C13.8749 8.80053 14.3389 7.87408 15.8307 7.87408H17.3444V4.92091C17.3444 4.92091 15.9708 4.68634 14.6579 4.68634C11.9173 4.68634 10.1252 6.34687 10.1252 9.35573V12.0001H7.07751V15.4696H10.1252V23.855C10.7361 23.9511 11.3621 24.0001 12 24.0001C12.6379 24.0001 13.264 23.9495 13.8749 23.855V15.4696H16.6711Z"
      fill="#FEFEFE"
    />
  </svg>
);
